<template>
    <local-grid :meta="meta" :data-source="data">
        <template #toolbarItems>
            <dx-item location="before">
                <dx-select-box
                    :data-source="enviromentStore.state.allAppList"
                    display-expr="name_app"
                    :value="app"
                    value-expr="kod_app"
                    width="300"
                    @value-changed="valueChangedSelectBox"
                />
            </dx-item>
            <dx-item location="after">
                <dx-button class="ai-button-base" hint="Обновить данные" @click="props.refreshHandler">
                    <ai-refresh-base />
                </dx-button>
            </dx-item>
        </template>
        <template #restrictions="{ data }">
            <div class="flex items-center justify-between pr-3">
                <div class="w-[92%] overflow-hidden text-ellipsis">
                    {{ data.data.department_permissions }}
                </div>
                <div class="justify-left">
                    <dx-button
                        :icon="AiEllipsis"
                        class="button-ellipsis cursor-pointer"
                        width="20px"
                        hint="Редактировать"
                        @click="showPopup(data)"
                    />
                </div>
            </div>
        </template>
    </local-grid>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { DxItem } from 'devextreme-vue/tree-list';
import { DxButton, DxSelectBox } from 'devextreme-vue';
import LocalGrid from '@/components/local-grid.vue';
import { getCookie } from '@/utils/cookies.js';
import usersLocalStore from '@/views/administration/users/store.js';
import enviromentStore from '@/store/enviroment-data.js';
import usersStore from '@/store/administration/users.js';
import rolesStore from '@/store/administration/roles.js';
import AiEllipsis from '@/assets/ai-ellipsis.svg';

const { state } = usersLocalStore;
const { getAllAppList } = enviromentStore;
const { usersState, getDepartmentsListWithGroupId } = usersStore;
const { rolesState, getAreaListByAppKod } = rolesStore;
const store = useStore();
const app = ref(+getCookie('app'));
const user = ref({});
const departments = ref([]);
const areas = computed(() => rolesState.areaListByAppKod);

const props = defineProps({
    refreshHandler: {
        type: Function,
        default: () => {
        },
    },
});

onMounted(async () => {
    if (enviromentStore.state.allAppList.length < 1) {
        await getAllAppList();
    }
    await getAreaListByAppKod(app.value);
    await getDepartmentsListWithGroupId();

    state.isSubdivisionDataLoaded = false;
    await store.dispatch('loadOrgSeparatorList');
    departments.value = usersState.departmentsList;
    user.value = state.userRequestBody;
});

const data = computed(() => {
    let dataOut = [];
    let departmentAndPermissions = [];
    if (user.value.data_rights) {
        for (const group of areas.value) {
            if (group.parent_id) continue;
            const dataItem = {};
            let str = '';
            const rightsGroup = user.value.data_rights.find(right => right.group_id === group.id);
            if (rightsGroup) {
                if (rightsGroup.departments === null) {
                    departmentAndPermissions.push('Полный доступ');
                } else {
                    rightsGroup.departments.forEach(department => {
                        str = departments.value.find(dep => dep.dep_id === department.id)?.name;
                        switch (department.permission) {
                            case 'N':
                                str += ' - Нет доступа';
                                break;
                            case 'R':
                                str += ' - Чтение';
                                break;
                            case 'W':
                                str += ' - Запись';
                                break;
                        }
                        departmentAndPermissions.push(str);
                    });
                }
                dataItem.id = group.id;
                dataItem.name = group.name;
                dataItem.department_permissions = departmentAndPermissions.join('; ');
                departmentAndPermissions = [];
                dataOut.push(dataItem);
            }
        }
    }
    return dataOut;
});

const valueChangedSelectBox = async event => {
    app.value = event.value;
    await getAreaListByAppKod(app.value);
};

const showPopup = async ({ data }) => {
    await getDepartmentsListWithGroupId(data.id);
    state.isClosingConfirmed = true;
    state.selectedGroupId = data.id;
    state.currentGroup = data;
    state.userCardPopupVisible = false;
    state.isSubdivisionDataLoaded = true;
    state.subdivisionPopupVisible = true;
};

const meta = {
    keyExpr: 'id',
    selectionMode: 'none',
    wordWrapEnabled: false,
    columns: [
        {
            dataField: 'id',
            caption: 'ID',
            visible: false,
            dataType: 'number',
        },
        {
            dataField: 'name',
            caption: 'Область приложения',
            width: 300,
            dataType: 'string',
        },
        {
            dataField: 'department_permissions',
            caption: 'Уровни доступа. Ограничения',
            cellTemplate: 'restrictions',
            width: 1,
            dataType: 'string',
        },
    ],
};
</script>

<style lang="scss" scoped>
:deep(.button-ellipsis.dx-button) {
    min-width: 0;
    min-height: 0;
    height: unset;
    display: flex;

    .dx-button-content {
        padding: 0;
        min-width: 0;
        min-height: 0;
    }

    .dx-icon {
        width: 20px;
        height: 20px;
        min-width: 0;
    }
}
</style>
